import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { PrepaidCardService } from './prepaid-card.service';

/**
 * "Prepaid Cards Not Accepted" pop-up (bottom sheet on mobile). Mounted once in
 * app.component.html and driven entirely by {@link PrepaidCardService}, so any
 * card add / edit / select flow just calls `prepaidCard.check(card, usage)`.
 */
@Component({
  selector: 'app-prepaid-card-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './prepaid-card-modal.component.html',
  styleUrls: ['./prepaid-card-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrepaidCardModalComponent {
  readonly modal = inject(PrepaidCardService);
  readonly text = this.modal.text;
}
